function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { PostPageComments_ItemFragmentDoc, PostPageComment_CommentFragmentDoc, usePostPage_CreateCommentMutation } from "sprout-graphql";
import { useCallback } from "react";
import update from "immutability-helper";
import generateRandomKey from "@sprout/client-lib/dist/generateRandomKey";
import generateOptimisticId from "@sprout/client-lib/dist/generateOptimisticId";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
export default function useCreateComment() {
    const [createComment] = usePostPage_CreateCommentMutation();
    const currentUser = useCurrentUser();
    const showSnackbar = useSnackbar();
    return useCallback((variables)=>{
        if (!currentUser) return;
        const date = new Date().toISOString();
        createComment({
            variables,
            optimisticResponse: {
                createComment: {
                    comment: {
                        id: generateOptimisticId(),
                        nodeId: generateRandomKey(),
                        text: variables.text,
                        createdAt: date,
                        updatedAt: date,
                        editedAt: null,
                        owner: currentUser,
                        __typename: "Comment"
                    },
                    __typename: "CreateCommentPayload"
                }
            },
            update (proxy, { data  }) {
                var ref;
                const comment = data === null || data === void 0 ? void 0 : (ref = data.createComment) === null || ref === void 0 ? void 0 : ref.comment;
                if (!comment) return;
                if ("parentCommentId" in variables) {
                    const options = {
                        fragment: PostPageComment_CommentFragmentDoc,
                        id: variables.parentCommentNodeId,
                        fragmentName: "PostPageComment_Comment"
                    };
                    const cache = proxy.readFragment(options);
                    proxy.writeFragment(_objectSpread({}, options, {
                        data: update(cache, {
                            replies: {
                                totalCount: {
                                    $apply: (totalCount)=>totalCount + 1
                                },
                                nodes: {
                                    $push: [
                                        comment
                                    ]
                                }
                            }
                        })
                    }));
                } else {
                    const options = {
                        fragment: PostPageComments_ItemFragmentDoc,
                        id: variables.parentItemNodeId,
                        fragmentName: "PostPageComments_Item"
                    };
                    const cache = proxy.readFragment(options);
                    proxy.writeFragment(_objectSpread({}, options, {
                        data: update(cache, {
                            commentCount: {
                                /**
                   * This is a compromise. Due to the race condition between
                   * optimistic response and subscriptions. There isn't a way
                   * to know the actual `commentCount`, so we can't just naively
                   * increment it.
                   *
                   * However, if the `commentCount` is 0, we do want the "1 comment"
                   * indicator to popup immediately.
                   */ $apply: (commentCount)=>commentCount === 0 ? 1 : commentCount
                            },
                            comments: {
                                nodes: {
                                    /**
                     * Fragment has no `__typename` because it is automatically
                     * injected. But optimistic response requires typename.
                     */ // @ts-ignore
                                    $apply: (nodes)=>[
                                            ...nodes.filter((node)=>node.id !== comment.id),
                                            _objectSpread({}, comment, {
                                                replies: {
                                                    pageInfo: {
                                                        endCursor: null,
                                                        __typename: "PageInfo"
                                                    },
                                                    totalCount: 0,
                                                    nodes: [],
                                                    __typename: "CommentsConnection"
                                                }
                                            }), 
                                        ]
                                }
                            }
                        })
                    }));
                }
            }
        }).catch(()=>{
            showSnackbar.error();
        });
    }, [
        createComment,
        currentUser,
        showSnackbar
    ]);
};
